import React from "react";
import howItWorkOneImg from "../../assets/images/webp/other/how-it-work-one-img.webp";
import howItWorkTwoImg from "../../assets/images/webp/other/how-it-work-two-img.webp";
import howItWorkThreeImg from "../../assets/images/webp/other/how-it-work-three-img.webp";
import howItWorkFourImg from "../../assets/images/webp/other/how-it-work-four-img.webp";
import howItWorkFiveImg from "../../assets/images/webp/other/how-it-work-five-img.webp";
import howItWorkRoadmap from "../../assets/images/webp/other/how-it-work-roadmap-img.webp";
import Heading from "../common/ui/Heading";

const HowItWork = () => {
  return (
    <>
      <div className="pb-[140px] px-4 max-xl:pb-[120px] max-lg:pb-26 max-md:pb-20 max-sm:pb-10">
        <div className="flex items-center justify-center flex-col">
          <Heading className="text-center pb-[86px] max-lg:pb-10 max-md:pb-6 max-sm:pb-4">
            How It Works
          </Heading>

          {/* Roadmap for smaller screens (Before md:) */}
          <div className="md:hidden">
            {/* Roadmap Container */}
            <div className="relative w-full flex flex-col items-center space-y-6">
              {/* Step 1 */}
              <div className="flex flex-col items-center">
                <div className="w-[60px] h-[60px] rounded-full bg-[#001A3D] flex items-center justify-center text-white text-lg font-bold">
                  <img
                    src={howItWorkOneImg}
                    width={50}
                    height={50}
                    alt="icon"
                    className="w-full max-w-[37px] pointer-events-none"
                  />
                </div>
                <p className="text-[#001A3D] font-semibold text-center mt-3">
                  Install App
                </p>
              </div>
              {/* Line connecting */}
              <div className="w-[2px] h-[40px] bg-[#001A3D] mx-auto"></div>

              {/* Step 2 */}
              <div className="flex flex-col items-center">
                <div className="w-[60px] h-[60px] rounded-full bg-[#001A3D] flex items-center justify-center text-white text-lg font-bold">
                  <img
                    src={howItWorkTwoImg}
                    width={50}
                    height={50}
                    alt="icon"
                    className="w-full max-w-[37px] pointer-events-none"
                  />
                </div>
                <p className="text-[#001A3D] font-semibold text-center mt-3">
                  Choose Your Goal
                </p>
              </div>
              {/* Line connecting */}
              <div className="w-[2px] h-[40px] bg-[#001A3D] mx-auto"></div>

              {/* Step 3 */}
              <div className="flex flex-col items-center">
                <div className="w-[60px] h-[60px] rounded-full bg-[#001A3D] flex items-center justify-center text-white text-lg font-bold">
                  <img
                    src={howItWorkThreeImg}
                    width={50}
                    height={50}
                    alt="icon"
                    className="w-full max-w-[37px] pointer-events-none"
                  />
                </div>
                <p className="text-[#001A3D] font-semibold text-center mt-3">
                  Water gets infused
                </p>
              </div>
              {/* Line connecting */}
              <div className="w-[2px] h-[40px] bg-[#001A3D] mx-auto"></div>

              {/* Step 4 */}
              <div className="flex flex-col items-center">
                <div className="w-[60px] h-[60px] rounded-full bg-[#001A3D] flex items-center justify-center text-white text-lg font-bold">
                  <img
                    src={howItWorkFourImg}
                    width={50}
                    height={50}
                    alt="icon"
                    className="w-full max-w-[37px] pointer-events-none"
                  />
                </div>
                <p className="text-[#001A3D] font-semibold text-center mt-3">
                  AI generates code
                </p>
              </div>
              {/* Line connecting */}
              <div className="w-[2px] h-[40px] bg-[#001A3D] mx-auto"></div>

              {/* Step 5 */}
              <div className="flex flex-col items-center">
                <div className="w-[60px] h-[60px] rounded-full bg-[#001A3D] flex items-center justify-center text-white text-lg font-bold">
                  <img
                    src={howItWorkFiveImg}
                    width={50}
                    height={50}
                    alt="icon"
                    className="w-full max-w-[37px] pointer-events-none"
                  />
                </div>
                <p className="text-[#001A3D] font-semibold text-center mt-3">
                  Transformation begins...
                </p>
              </div>
            </div>
          </div>

          {/* Existing Desktop Roadmap (after md:) */}
          <div className="relative max-w-[1074px] max-md:hidden  mx-auto mt-10">
            <img
              src={howItWorkRoadmap}
              alt="road-map"
              width={1048}
              height={285}
              className="w-full max-w-[1074px] h-[285px]"
            />
            <p className="font-semibold text-sm leading-[19.31px] text-[#001A3D] absolute max-w-[133px] text-center top-[45%] left-[5%]">
              Install App
            </p>
            <p className="font-semibold text-sm leading-[19.31px] text-[#001A3D] text-center absolute max-w-[180px] top-[72%] left-[22%]">
              Choose Your Goal
            </p>
            <p className="font-semibold text-sm leading-[19.31px] text-[#001A3D] text-center absolute max-w-[163px] left-[43%] top-[55%] -translates-x-1/2 -translate-y-1/2">
              Water gets infused
            </p>
            <p className="font-semibold text-sm leading-[19.31px] text-[#001A3D] text-center absolute max-w-[161px] bottom-[12%] right-[22%]">
              AI generates code
            </p>
            <p className="font-semibold text-sm leading-[19.31px] text-[#001A3D] text-center absolute max-w-[149px] right-0 bottom-[35%]">
              Transformation begins...
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default HowItWork;
